webpackJsonp([35783957827783],{

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  text-decoration: none;\n  color: #008584;\n  &:hover {\n    text-decoration: underline;\n  }\n"], ["\n  text-decoration: none;\n  color: #008584;\n  &:hover {\n    text-decoration: underline;\n  }\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  font-size: 22px;\n  font-weight: 500;\n  color: ", ";\n"], ["\n  font-size: 22px;\n  font-weight: 500;\n  color: ", ";\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  font-size: 16px;\n"], ["\n  font-size: 16px;\n"]);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(34);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(42);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _colors = __webpack_require__(25);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	var EntryLink = (0, _styledComponents2.default)(_gatsbyLink2.default)(_templateObject2);
	
	var TitleWrapper = _styledComponents2.default.div(_templateObject3);
	
	var Title = _styledComponents2.default.div(_templateObject4, _colors2.default.DARKEST);
	
	var Date = _styledComponents2.default.span(_templateObject5);
	
	var BlogEntry = function BlogEntry(_ref) {
	  var node = _ref.node;
	  return _react2.default.createElement(
	    "div",
	    { key: node.id },
	    _react2.default.createElement(
	      TitleWrapper,
	      null,
	      _react2.default.createElement(
	        EntryLink,
	        { to: node.fields.slug },
	        _react2.default.createElement(
	          Title,
	          null,
	          node.frontmatter.title
	        )
	      ),
	      _react2.default.createElement(
	        Date,
	        null,
	        node.frontmatter.date
	      )
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      node.excerpt
	    )
	  );
	};
	
	exports.default = function (_ref2) {
	  var data = _ref2.data;
	
	  return _react2.default.createElement(
	    Wrapper,
	    null,
	    data.allMarkdownRemark.edges.map(function (_ref3) {
	      var node = _ref3.node;
	      return _react2.default.createElement(BlogEntry, { node: node });
	    })
	  );
	};
	
	var query = exports.query = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-01b687512f118a7c6ffd.js